"use client";

import { Suspense } from "react";

import FilterSheet from "@/components/sheets/FilterSheet";
import FilterBudgetSection from "@/components/sheets/FilterSheet/FilterBudgetSection";
import FilterCategoryIndustryNav from "@/components/sheets/FilterSheet/FilterCategoryIndustryNav";
import FilterKeywordsSection from "@/components/sheets/FilterSheet/FilterKeywordsSection";
import FilterPageSizeSection from "@/components/sheets/FilterSheet/FilterPageSizeSection";
import type { CategoryFilterNavRow } from "@/lib/utils/public-category-listing-payload";

const getKeywords = (categoryTitle: string) => {
	if (categoryTitle.includes("Website Development")) {
		return ["Default", "Wordpress", "Shopify", "Custom"];
	}

	return null;
};

type Props = {
	categoryTitle: string;
	filterMainCategory?: CategoryFilterNavRow;
	filterSelectedMainIds?: string[];
	filterSelectedSubcategoryIds?: string[];
	/** From server: full main list in `order` (see `getCachedAllPublicCategoriesAsc`). */
	filterNavMainCategories?: CategoryFilterNavRow[];
	filterNavSubcategories?: CategoryFilterNavRow[];
	sectorIdsByMainId?: Record<string, string[]>;
	/** Keep filter apply on the current URL (e.g. `/search/keyword`) instead of navigating to `/categories/...`. */
	filterStayOnCurrentPath?: boolean;
};

export default function FilterPopup({
	categoryTitle,
	filterMainCategory,
	filterSelectedMainIds = [],
	filterSelectedSubcategoryIds = [],
	filterNavMainCategories,
	filterNavSubcategories,
	sectorIdsByMainId,
	filterStayOnCurrentPath = false,
}: Props) {
	const keywords = getKeywords(categoryTitle);
	const hasCategoryNav =
		filterMainCategory != null &&
		Array.isArray(filterNavMainCategories) &&
		Array.isArray(filterNavSubcategories);
	const navKey = `${filterSelectedMainIds.join("-")}__${filterSelectedSubcategoryIds.join("-")}`;

	return (
		<FilterSheet
			glassToolbar
			removeParamsWhen={{
				minPrice: "0",
				maxPrice: "0",
				search: "Default",
				limit: "12",
			}}
		>
			{hasCategoryNav ? (
				<>
					<FilterCategoryIndustryNav
						key={`${filterMainCategory._id}-${navKey}`}
						mainCategories={filterNavMainCategories}
						subcategories={filterNavSubcategories}
						filterMainCategory={filterMainCategory}
						filterSelectedMainIds={filterSelectedMainIds}
						filterSelectedSubcategoryIds={filterSelectedSubcategoryIds}
						sectorIdsByMainId={sectorIdsByMainId}
						filterStayOnCurrentPath={filterStayOnCurrentPath}
					/>
					<hr className="my-6 border-t border-secondary/30" />
				</>
			) : null}
			<Suspense>
				<FilterBudgetSection />
			</Suspense>
			<hr className="my-6 border-t border-secondary/30" />
			<Suspense>
				<FilterPageSizeSection />
			</Suspense>
			{keywords !== null && (
				<Suspense>
					<hr className="my-6 border-t border-secondary/30" />
					<FilterKeywordsSection
						queryKey="search"
						defaultKey="Default"
						keywords={keywords}
					/>
				</Suspense>
			)}
		</FilterSheet>
	);
}
